/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { eventType } from './analyticsWebTypes';
import { isActionEventType } from './isActionEventType';

const actionEventTypes = Object.freeze([eventType.OPERATIONAL, eventType.TRACK, eventType.UI]);

export function validateActionEventType(type: string): any {
	if (!isActionEventType(type)) {
		throw new Error(`Invalid action event type: ${type}, must be one of: [${actionEventTypes}]`);
	}
	return true;
}
